/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Remaining_Chars_Cps_TitleInputs */

const en_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining Characters to CPS`)
};

const fr_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres restants au CPS`)
};

const de_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbleibende Zeichen bis CPS`)
};

const it_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaggi rimanenti per CPS`)
};

const ru_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставшиеся символы для CPS`)
};

const es_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personajes restantes para CPS`)
};

const zh_cn2_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剩余字符数至 CPS`)
};

const ja_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残りの文字はCPSへ`)
};

const hi_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेष पात्रों को सीपीएस को सौंपना है।`)
};

const pt_pt2_summary_remaining_chars_cps_title = /** @type {(inputs: Summary_Remaining_Chars_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personagens restantes para o CPS`)
};

/**
* | output |
* | --- |
* | "Remaining Characters to CPS" |
*
* @param {Summary_Remaining_Chars_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_remaining_chars_cps_title = /** @type {((inputs?: Summary_Remaining_Chars_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Remaining_Chars_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_remaining_chars_cps_title(inputs)
	if (locale === "de") return de_summary_remaining_chars_cps_title(inputs)
	if (locale === "it") return it_summary_remaining_chars_cps_title(inputs)
	if (locale === "ru") return ru_summary_remaining_chars_cps_title(inputs)
	if (locale === "es") return es_summary_remaining_chars_cps_title(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_remaining_chars_cps_title(inputs)
	if (locale === "ja") return ja_summary_remaining_chars_cps_title(inputs)
	if (locale === "hi") return hi_summary_remaining_chars_cps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_remaining_chars_cps_title(inputs)
	return en_summary_remaining_chars_cps_title(inputs)
});